export enum EMenuEntryType {
  STATIC = 'STATIC',
  STATIC_PAGE = 'STATIC_PAGE',
  CATEGORY = 'CATEGORY',
  SUBCATEGORY = 'SUBCATEGORY',
}
